import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={36}
    height={39}
    viewBox={'0 0 36 39'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M32.6 4.552h-2.821v-1.5c0-1.37-1.12-2.49-2.49-2.49s-2.49 1.12-2.49 2.49v1.5H7.359c-1.74 0-3.16 1.42-3.16 3.16v27.91c0 1.74 1.42 3.16 3.16 3.16h25.25c1.74 0 3.16-1.42 3.16-3.16V7.713c0-1.74-1.42-3.16-3.16-3.16h-.01Zm-5.321-2.99c.82 0 1.49.67 1.49 1.5v1.5h-2.99v-1.5c0-.82.67-1.5 1.49-1.5h.01Zm7.48 34.06c0 1.19-.97 2.16-2.16 2.16H11.34c-1.19 0-2.16-.97-2.16-2.16V7.713c0-1.19.97-2.16 2.16-2.16h17.44v2.82c0 .82-.67 1.5-1.5 1.5s-1.49-.67-1.49-1.5v-.66c0-.28-.22-.5-.5-.5s-.5.22-.5.5v.66c0 1.37 1.12 2.49 2.49 2.49s2.49-1.12 2.49-2.49v-2.82h2.82c1.19 0 2.16.97 2.16 2.16v27.91h.01Z"
    />
    <Path
      fill={props.stroke || '#27B9E0'}
      d="M12.669 12.191h8.64c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-8.64c-.28 0-.5.22-.5.5s.22.5.5.5ZM31.279 15.184h-18.61c-.28 0-.5.22-.5.5s.22.5.5.5h18.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5ZM31.279 19.172h-18.61c-.28 0-.5.22-.5.5s.22.5.5.5h18.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5ZM31.279 23.164h-18.61c-.28 0-.5.22-.5.5s.22.5.5.5h18.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5ZM31.279 27.14h-18.61c-.28 0-.5.22-.5.5s.22.5.5.5h18.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5ZM31.279 31.133h-18.61c-.28 0-.5.22-.5.5s.22.5.5.5h18.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5ZM3.2 7.71c0-1.26.57-2.39 1.46-3.16H3.37C1.63 4.55.208 5.97.208 7.71v27.911c0 1.74 1.42 3.16 3.16 3.16h1.29a4.142 4.142 0 0 1-1.46-3.16V7.711Z"
    />
  </Svg>
);
export default SvgComponent;
